<template>
	<div>
		<div class="wrapper" :style="'width:'+width+'px'">

			<div v-for="(item,index) in baseData.list2" :class="showDetail?'detail-style':''">
				<div v-if="item.detail.type==0" class="hot-style">
					<img :src="item.detail.imageUrl0" />
					<a v-for="(subItem,index) in item.hotData" :href="subItem.link" :style="setStyle(subItem,item.detail.per)" :class="showDetail?'showHot':''">
					</a>
					<div class="text-detail" v-if="showDetail">素材描述：{{item.detail.desc}}</div>
				</div>
				<div v-if="item.detail.type==3" class="form-contain">
					<img :src="item.detail.imageUrl0" />
					<div class="form" :style="'top:'+item.detail.position+'%'">
						<input v-model="tel" type="number" placeholder="请输入手机号" pattern="[0-9]*" oninput="if(value.length>11){value=value.slice(0,11)}" />
						<div class="btn" @click="geCode"><img :src="item.detail.imageUrl1" /></div>
					</div>
					<div class="text-detail" v-if="showDetail">素材描述：{{item.detail.desc}}</div>
				</div>
				<div v-if="item.detail.type==2" style="position: relative;">
					<img :src="item.detail.imageUrl0" />
					<div class="vedio">
						<iframe class="video_iframe" id="myFrame" frameborder="0" :src="'https://v.qq.com/iframe/player.html?vid='+item.detail.link+'&tiny=0&auto=0'" allowfullscreen></iframe>

					</div>
					<div class="text-detail" v-if="showDetail">素材描述：{{item.detail.desc}}</div>
				</div>
			</div>
		</div>
		<div class="mask-tips" v-if="showTips">
			<div class="mask-content">
				<p class="close">
					<a href="#" @click="showTips=false"></a>
				</p>
				<h2 class="title">恭喜您！</h2>
				<p class="tips">{{tips}}</p>
			</div>
		</div>
		<div class="show-detail" v-if="showCode" @click="showDetail=!showDetail">{{showDetail?"隐藏":"显示"}}详情</div>
		<div class="show-text" v-show="showCode">手机扫一扫即可预览</div>
		<canvas id="code"  v-show="showCode"></canvas>
	</div>

</template>
<script>
	import '../../util/setDplus.js';
	import QRCode from 'qrcode'
	export default {
		name: 'demo',
		components: {
			QRCode: QRCode
		},
		data() {
			return {
				tel: '',
				tips: '',
				width: '',
				showCode: false,
				showDetail: false,
				showTips: false,
				baseData: {},

				metaData: [{
						content: '清尾特价房大优惠',
						name: 'wxm:timeline_title'
					},
					{
						content: '恒大清尾特价房，每日每盘限5套，分期付款，首期5%券',
						name: 'wxm:appmessage_desc'

					},
					{
						content: 'http://wximg.qq.com/wxp/moment/NyW-Zv-mX/img/share.jpg',
						name: 'wxm:img_url'

					}
				]
			}
		},
		methods: {
			judgeNull(str) {
				if(typeof(str) == "undefined" || "" + str == "undefined" || str == null) {
					return false;
				} else {
					return true
				}
			},
			setStyle(item, per) {

				var str1 = item.x * 1 / this.baseData.width * 100 + "%";
				var str = "left:" + item.x * 1 / this.baseData.width * 100 + "%;width:" + item.w * 1 / this.baseData.width * 100 + "%;height:" + item.h * 1 / (this.baseData.width / per) * 100 + "%;top:" + item.y * 1 / (this.baseData.width / per) * 100 + "%";
				return str

			},
			geCode() {
				if(this.tel.length != 11) {
					this.$message({
						message: "请输入正确的手机号码！",
						type: 'warning'
					});

				} else {
					var param = {
						phone: this.tel,
						sessionId: 'random',
						fromSource: 700
					}
					this.Post("rest/coupon/get7Coupon", param).then((data) => {
						if(data.result) {
							this.tips = data.objValue;
							this.showTips = true;
						} else {
							this.$message({
								message: data.value,
								type: 'warning'
							});
						}

					})

				}
			},
			initData(id) {
				var url=""
				if(this.$route.query.type=="muban"){
					url="/rest/advertisement/queryTemplate/"+id
				}else{
					url="/rest/advertisement/queryAdvertisement/"+id+"/"+this.$route.query.adType
				}
				this.Post(url).then((data) => {
					if(data.result) {
						this.baseData = eval('(' + data.objValue.content + ')');
						document.title = this.baseData.title;
						if(document.documentElement.clientWidth < 500) {
							this.width = '100%'
						} else {

							this.width = this.baseData.width;
							this.showCode = true;
						}
						const head = document.getElementsByTagName('head')
						this.metaData.map(function(item) {
							const meta = document.createElement('meta')
							meta.content = item.content;
							meta.name = item.name;
							head[0].append(meta)
						})

						const s = document.createElement('script');
						s.type = 'text/javascript';
						s.src = "//wximg.qq.com/wxp/libs/wxmoment/0.0.4/wxmoment.min.js";
						head[0].appendChild(s);
						var code = document.getElementById('code')
						// 将获取到的数据（val）画到msg（canvas）上
						QRCode.toCanvas(code, window.location.href, function(error) {
							console.log(error)
						})
						setTimeout(function() {
							var share = new WxMoment.Share();
						}, 1000)
					} else {
						this.$message({
							message: data.value,
							type: 'warning',
						});
					}
				})
			},
		},
		mounted() {
			this.uploadUrl = this.baseUrl + '/rest/common/upload';
			if(this.judgeNull(this.$route.query.id)) {
				this.templeId = this.$route.query.id;
				this.initData(this.$route.query.id)
			}

		}
	}
</script>
<style scoped lang="less">
	.wrapper {
		margin: 0 auto;
		width: 100%;
		img {
			width: 100%;
			display: block;
		}
		.hot-style {
			position: relative;
			a {
				position: absolute;
			}
		}
		.text-detail {
			text-align: right;
			position: absolute;
			left: -242px;
			color: #ce000a;
			top: 40px;
			width: 218px;
			display: inline-block;
			height: 100px;
			overflow-wrap: break-word;
		}
		.show-detail {
			background: #ce000a;
			opacity: 0.6;
		}
		#myFrame {
			display: block;
			z-index: 1;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 92.8%;
		}
		.vedio {
			position: absolute;
			top: 4%;
			left: 9%;
			width: 82%;
			height: 0;
			padding-bottom: 53.4%;
		}
		.form-contain {
			position: relative;
			width: 100%;
			img {
				width: 100%
			}
			.form {
				position: absolute;
				left: 5%;
				height: 100%;
				width: 90%;
				display: flex;
				justify-content: space-around;
				align-items: center;
				input {
					height: 32px;
					width: 12rem;
				}
				.btn {
					width: 80px;
					min-height: 32px;
					cursor: pointer;
				}
			}
		}
	}
	
	.mask-tips {
		position: fixed;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.6);
		top: 0;
		left: 0;
		z-index: 999;
		.mask-content {
			width: 66%;
			background: #f5f5f5;
			position: absolute;
			top: 18%;
			left: 50%;
			margin-left: -33%;
			font-size: 1rem;
			text-align: center;
			border-radius: 12px;
			p.close {
				position: absolute;
				cursor: pointer;
				width: 100%;
				/* padding-top: 5px; */
				padding-right: 10px;
				a {
					cursor: pointer;
					position: absolute;
					display: inline-block;
					right: 0.8rem;
					top: -0.6rem;
					width: 16px;
					height: 16px;
					background: url(../../assets/close.jpg) no-repeat;
					background-size: contain;
				}
			}
			.title {
				text-align: center;
				height: 2rem;
				line-height: 2rem;
				font-weight: bold;
				color: #fff;
				font-size: 1rem;
				border-top-left-radius: 12px;
				border-top-right-radius: 12px;
				background: rgb(241, 155, 56);
				margin: 0
			}
			.tips {
				text-align: center;
				font-weight: bold;
				color: #000;
				font-size: 0.8rem;
				padding: 0.1rem 0 0.2rem 0.1rem;
			}
		}
	}
	
	#code {
		position: fixed;
		right: 40px;
		bottom: 100px;
	}
	
	.show-detail {
		color: #fff;
		text-align: center;
		height: 32px;
		line-height: 32px;
		background: #ce000a;
		width: 228px;
		position: fixed;
		right: 40px;
		bottom: 60px;
		cursor: pointer;
	}
	#code{
		width: 228px!important;
		height: 228px!important
	}
	.show-text {
		color: #333;
		text-align: center;
		height: 36px;
		line-height: 42px;
		background: #fff;
		width: 228px;
		position: fixed;
		right: 40px;
		bottom: 322px;
		cursor: pointer;
	}
	
	.showHot {
		background: #ce000a;
		opacity: 0.6;
	}
	
	.detail-style {
		border-top: 1px solid #d9d9d9;
	}
</style>


// WEBPACK FOOTER //
// src/views/MakePost/Preview.vue